import { participationSelectors } from './../participation/participation.selectors'
import { bookingActions } from 'src/app/features/booking/booking.actions'
import { BookableSlot } from './../../bookable-slot/bookable-slot'
import { Constants } from 'src/app/shared/constants'
import { BookingShowModalComponent } from './../show-modal/show.component'
import { bookingSelectors } from './../booking.selectors'
import { productGroupActions } from './../../product/product-group/product-group.actions'
import { productGroupSelectors } from './../../product/product-group/product-group.selectors'
import {
  ProductGroup,
  ProductGroupType
} from './../../product/product-group/product-group'
import { RequestQueryBuilder, CondOperator } from '@nestjsx/crud-request'
import { productSelectors } from '../../product/product.selectors'
import { Dictionary } from '@ngrx/entity'
import { productActions } from '../../product/product.actions'
import { settingsActions } from '../../../core/settings/settings.actions'
import { settingSelectors } from '../../../core/settings/settings.selectors'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { AppState } from '../../../core/core.state'
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import {
  BehaviorSubject,
  combineLatest,
  Observable,
  of,
  Subject,
  Subscription
} from 'rxjs'
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  take,
  tap,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import { Product } from '../../product/product'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import moment from 'moment-mini'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME
import { organizationSelectors } from '../../organization/organization.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { BookingCreationType } from '../booking'
import { BookingCreateComponent } from '../create/create.component'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { ExtendedBookableSlot } from 'src/app/shared/components/schedule/slot'

interface ScheduleConfig {
  slotInterval: number
  openTime: string
  closeTime: string
  scheduleHeaderWidth: number
}
@UntilDestroy()
@Component({
  selector: 'booking-overview-schedule',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OverviewScheduleComponent implements OnInit {
  @Input() bookingId: number

  public form: UntypedFormGroup
  public selectedLanguage$: Observable<string>
  public selectedFilters$: Observable<any>
  public filterIsSelected$: Observable<boolean>
  public defaultStarDay = moment().startOf('year')
  public selectedBookableProductIds$: Observable<number[]>
  public selectedProductGroupIds$: Observable<number[]>
  // public totalMainProductIds: number[] = []
  // public totalDependantsProductIds: number[] = []

  public allProducts$: Observable<Product[]>
  public productEntities$: Observable<Dictionary<Product>>
  public bookableProducts$: Observable<Product[]>
  public productGroups$: Observable<ProductGroup[]>
  public bookableSlots$: Observable<ExtendedBookableSlot[]>
  public isLoading$: Observable<boolean>
  public targetProductsIds$: Observable<number[]>
  // public totalTargetedProductsIds$: BehaviorSubject<any> =
  //   new BehaviorSubject<any>(null)
  // public targetedProductsIds$: BehaviorSubject<any> = new BehaviorSubject<any>(
  //   null
  // )
  public scheduleConfig$: Observable<ScheduleConfig>
  public selectedDay$: Subject<moment.Moment> = new BehaviorSubject(
    moment().startOf('day')
  )
  public bsModalRef: BsModalRef
  private subscriptions: Subscription[] = []
  private didFetchProductIds: Map<number, boolean> = new Map()

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private modalService: BsModalService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isLoading$ = combineLatest([
      this.store.select(productSelectors.selectIsLoading),
      this.store.select(productGroupSelectors.selectIsLoading),
      this.store.select(bookingSelectors.selectIsLoading)
    ]).pipe(map(([pgL, pL, bL]) => pgL || pL || bL))

    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.selectedFilters$ = this.store
      .select(settingSelectors.selectById, 'selectedFilters')
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        tap((item) => {
          this.form.controls.selectedBookableProductIds.setValue(
            item?.selectedBookableProductIds
          )
          this.form.controls.selectedProductGroupIds.setValue(
            item?.selectedProductGroupIds
          )
        })
      )

    this.form = this.fb.group({
      selectedProductGroupIds: [null, []],
      selectedBookableProductIds: [null, []]
    })

    this.selectedBookableProductIds$ =
      this.form.controls.selectedBookableProductIds.valueChanges

    this.selectedProductGroupIds$ =
      this.form.controls.selectedProductGroupIds.valueChanges

    this.filterIsSelected$ = combineLatest([
      this.selectedBookableProductIds$,
      this.selectedProductGroupIds$
    ]).pipe(
      withLatestFrom(this.selectedFilters$),
      debounceTime(10),
      tap(
        ([
          [selectedBookableProductIds, selectedProductGroupIds],
          selectedFilters
        ]) => {
          if (
            this.isFiltersEmpty(
              selectedBookableProductIds,
              selectedProductGroupIds
            )
          ) {
            return []
          }

          const targetFilters = {
            selectedBookableProductIds,
            selectedProductGroupIds
          }

          if (
            JSON.stringify(targetFilters) != JSON.stringify(selectedFilters)
          ) {
            this.store.dispatch(
              settingsActions.setOneById({
                id: 'selectedFilters',
                value: targetFilters
              })
            )
          }
        }
      ),

      map(([[a, b]]) => Boolean(a?.length || b?.length)),
      distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b))
    )

    this.targetProductsIds$ = combineLatest([
      this.selectedBookableProductIds$,
      this.selectedProductGroupIds$,
      this.selectedFilters$,
      this.store.select(productGroupSelectors.selectEntities),
      this.selectedDay$
    ]).pipe(
      map(
        ([
          selectedBookableProductIds,
          selectedProductGroupIds,
          selectedFilters,
          productGroupEntities
        ]) => {
          let targetProductIds: number[] = []

          if (selectedBookableProductIds?.length) {
            targetProductIds.push(...selectedBookableProductIds)
          }

          if (selectedProductGroupIds?.length) {
            for (const selectedProductGroupId of selectedProductGroupIds) {
              const groupProductIds =
                productGroupEntities[selectedProductGroupId]?.products ?? []
              if (groupProductIds?.length) {
                targetProductIds.push(...groupProductIds)
              }
            }
          }

          if (!targetProductIds?.length) {
            return []
          }

          return Array.from(new Set(targetProductIds))
        }
      ),
      distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b))
    )

    combineLatest([this.selectedDay$])
      .pipe(untilDestroyed(this), debounceTime(DEBOUNCED_TIME))
      .subscribe(([selectedDay]) => {
        console.log(
          `Will fetch bookings from range ${selectedDay?.toISOString()} - ${selectedDay
            .clone()
            .add(24, 'hours')
            .toISOString()}`
        )
        this.store.dispatch(bookingActions.resetState())
        this.store.dispatch(
          bookingActions.fetchMany({
            params: RequestQueryBuilder.create({
              join: [
                { field: 'allowedLinkedProducts' },
                { field: 'participations' },
                { field: 'participations.organization' }
              ],
              search: {
                startDate: {
                  [CondOperator.GREATER_THAN_EQUALS]: moment(
                    selectedDay?.toISOString()
                  )
                    .subtract(2, 'hour')
                    ?.toISOString()
                },
                endDate: {
                  [CondOperator.LOWER_THAN]: moment(
                    selectedDay.clone().add(24, 'hours').toISOString()
                  )
                    .add(2, 'hour')
                    ?.toISOString()
                }
              }
            })
          })
        )
      })

    this.bookableSlots$ = combineLatest([
      this.store.select(bookingSelectors.selectAll),
      this.selectedDay$,
      this.targetProductsIds$.pipe(startWith([])),
      this.store.select(productSelectors.selectEntities),
      this.store.select(participationSelectors.selectEntities),
      this.store.select(organizationSelectors.selectEntities)
    ]).pipe(
      map(
        ([
          bookings,
          selectedDay,
          targetProductsIds,
          productEntities,
          participationEntities,
          organizationEntities
        ]) => {
          const filterBookingsByDate = bookings.filter((booking) => {
            return (
              moment(selectedDay).format('YYYY-MM-DD') ==
                moment(booking.startDate).format('YYYY-MM-DD') ||
              (moment(selectedDay).format('YYYY-MM-DD') <=
                moment(booking.endDate).format('YYYY-MM-DD') &&
                moment(selectedDay).format('YYYY-MM-DD') >=
                  moment(booking.startDate).format('YYYY-MM-DD'))
            )
          })

          // side load products
          this.fetchProductsById(
            filterBookingsByDate.reduce(
              (acc, booking) => [
                ...acc,
                booking.productId,
                booking.linkedProductId
              ],
              []
            )
          )

          const allDependantProductIds: number[] = bookings.reduce(
            (acc, booking) => {
              const dependantProductsFromProduct =
                productEntities[booking.productId]?.dependantProducts ?? []

              if (!dependantProductsFromProduct.length) {
                return acc
              }
              return [...acc, ...dependantProductsFromProduct]
            },
            []
          )

          const mainFilteredValue = filterBookingsByDate
            .filter(
              (bk) =>
                (bk.productId && targetProductsIds.includes(bk.productId)) ||
                (bk.linkedProductId &&
                  targetProductsIds.includes(bk.linkedProductId))
            )
            .map((booking) => {
              return {
                bookingId: booking.id,
                startDate: booking.startDate,
                endDate: booking.endDate,
                name: `${
                  productEntities[booking.linkedProductId]?.description ?? ''
                } ${productEntities[booking.productId]?.description} - `,
                isAvailable: true,
                maxParticipants: booking.maxParticipants || 0,
                availableParticipantCount:
                  booking.availableParticipantCount || 0,
                currentParticipantCount: booking.currentParticipantCount || 0,
                bookableProductId: booking.productId,
                memo: booking.memo,
                bookableProductDescription:
                  productEntities[booking.productId]?.description,
                linkedProductId: booking.linkedProductId,
                linkedProductDescription:
                  productEntities[booking.linkedProductId]?.description,
                group: booking.linkedProductId ?? booking.productId,
                organizationAbbrv: this.getOrgAbbrv(
                  booking,
                  participationEntities,
                  organizationEntities
                ),
                dependantProducts:
                  productEntities[booking.productId]?.dependantProducts ?? [],
                isDependantProduct: allDependantProductIds.includes(
                  booking.productId
                )
              }
            })

          const filteredBookings = mainFilteredValue.filter(
            (booking: any) =>
              targetProductsIds.includes(booking.bookableProductId) ||
              targetProductsIds.includes(booking.linkedProductId) ||
              targetProductsIds.some((it) =>
                booking?.dependantProducts?.includes(it)
              ) ||
              targetProductsIds.some((it) =>
                booking?.dependantProducts?.includes(it)
              )
          )
          let totalBookings: ExtendedBookableSlot[] = [...filteredBookings]
          const filterBookingsByDateForDependants = filterBookingsByDate.filter(
            (bk) =>
              !(
                (bk.productId && targetProductsIds.includes(bk.productId)) ||
                (bk.linkedProductId &&
                  targetProductsIds.includes(bk.linkedProductId))
              )
          )
          //for each booking.dependantProducts create a foggy booking
          filteredBookings.forEach((bk: any) => {
            bk.dependantProducts.forEach((dpP) => {
              totalBookings.push({
                startDate: bk.startDate,
                endDate: bk.endDate,
                name: productEntities[dpP]?.description ?? '',
                isAvailable: true,
                bookingId: bk.bookingId,
                parentProductId: bk.bookableProductId,
                parentDescription:
                  productEntities[bk.bookableProductId]?.description ??
                  productEntities[dpP]?.description ??
                  '',
                maxParticipants: 0,
                availableParticipantCount: 0,
                currentParticipantCount: 0,
                bookableProductDescription:
                  productEntities[dpP]?.description ?? '',
                linkedProductId: dpP,
                linkedProductDescription:
                  productEntities[dpP]?.description ?? '',
                group: dpP,
                bookableProductId: dpP,
                dependantProducts: productEntities[dpP]?.dependantProducts,
                isDependantProduct: true,
                foggy: true
              })
            })
          })

          //for each targetedProductsIds create a foggy booking if the productId is dependant of some booking
          targetProductsIds.forEach((productId) => {
            filteredBookings
              .filter(
                (bk) =>
                  (bk.bookableProductId == productId ||
                    bk.linkedProductId == productId) &&
                  bk?.dependantProducts?.includes(productId) &&
                  !totalBookings.find(
                    (it) =>
                      it.bookingId == bk.bookingId && it.group == productId
                  )
              )
              .forEach((bk) => {
                totalBookings.push({
                  startDate: bk.startDate,
                  endDate: bk.endDate,
                  name: productEntities[productId]?.description ?? '',
                  isAvailable: true,
                  bookingId: bk.bookingId,
                  maxParticipants: 0,
                  availableParticipantCount: 0,
                  currentParticipantCount: 0,
                  bookableProductDescription:
                    productEntities[productId]?.description ?? '',
                  linkedProductId: productId,
                  linkedProductDescription:
                    productEntities[productId]?.description ?? '',
                  group: productId,
                  bookableProductId: productId,
                  dependantProducts:
                    productEntities[productId]?.dependantProducts,
                  isDependantProduct: true,
                  foggy: true
                })
              })

            filterBookingsByDateForDependants.forEach((bkDp) => {
              if (
                productEntities[productId].dependantProducts?.includes(
                  bkDp.productId
                ) ||
                productEntities[productId].dependantProducts?.includes(
                  bkDp.linkedProductId
                )
              ) {
                totalBookings.push({
                  startDate: bkDp.startDate,
                  endDate: bkDp.endDate,
                  name: productEntities[productId].dependantProducts?.includes(
                    bkDp.productId
                  )
                    ? productEntities[bkDp.productId]?.description
                    : productEntities[productId].dependantProducts?.includes(
                          bkDp.linkedProductId
                        )
                      ? productEntities[bkDp.linkedProductId]?.description
                      : '',
                  isAvailable: true,
                  bookingId: bkDp.id,
                  parentProductId: bkDp.productId,
                  parentDescription: productEntities[
                    productId
                  ].dependantProducts?.includes(bkDp.productId)
                    ? productEntities[bkDp.productId]?.description
                    : productEntities[productId].dependantProducts?.includes(
                          bkDp.linkedProductId
                        )
                      ? productEntities[bkDp.linkedProductId]?.description
                      : '',
                  maxParticipants: 0,
                  availableParticipantCount: 0,
                  currentParticipantCount: 0,
                  bookableProductDescription: productEntities[
                    productId
                  ].dependantProducts?.includes(bkDp.productId)
                    ? productEntities[bkDp.productId]?.description
                    : productEntities[productId].dependantProducts?.includes(
                          bkDp.linkedProductId
                        )
                      ? productEntities[bkDp.linkedProductId]?.description
                      : '',
                  linkedProductId: productEntities[
                    productId
                  ].dependantProducts?.includes(bkDp.productId)
                    ? bkDp.productId
                    : productEntities[productId].dependantProducts?.includes(
                          bkDp.linkedProductId
                        )
                      ? bkDp.linkedProductId
                      : null,
                  linkedProductDescription: productEntities[
                    productId
                  ].dependantProducts?.includes(bkDp.productId)
                    ? productEntities[bkDp.productId]?.description
                    : productEntities[productId].dependantProducts?.includes(
                          bkDp.linkedProductId
                        )
                      ? productEntities[bkDp.linkedProductId]?.description
                      : '',
                  group: productId,
                  bookableProductId: productId,
                  dependantProducts:
                    productEntities[productId]?.dependantProducts,
                  isDependantProduct: true,
                  foggy: true
                })
              }
            })
          })

          return totalBookings
        }
      )
    )
    //cambiar a suscription
    this.scheduleConfig$ = combineLatest([this.bookableSlots$]).pipe(
      map(([bookableSlots]) => {
        let scheduleConfig: ScheduleConfig = {
          slotInterval: 15,
          openTime: '07:00',
          closeTime: '23:59',
          scheduleHeaderWidth: 4
        }

        bookableSlots.map((booking) => {
          if (
            moment(booking.startDate).format('HH:mm') < scheduleConfig.openTime
          ) {
            scheduleConfig.openTime = moment(booking.startDate).format('HH:mm')
          }
          if (
            moment(booking.endDate).format('HH:mm') > scheduleConfig.closeTime
          ) {
            scheduleConfig.closeTime = moment(booking.endDate).format('HH:mm')
          }
        })
        return scheduleConfig
      })
    )
    //  this.store.dispatch(productActions.fetchMany({}))
    this.store.dispatch(
      productGroupActions.fetchMany({
        params: RequestQueryBuilder.create({
          join: [{ field: 'products' }],
          search: {
            type: ProductGroupType.REPORT_GROUP
          }
        })
      })
    )

    this.allProducts$ = this.store.select(productSelectors.selectAll)
    this.productGroups$ = this.store
      .select(productGroupSelectors.selectAll)
      .pipe(
        map((productGroups) =>
          productGroups.filter(
            (productGroup) => productGroup.type == ProductGroupType.REPORT_GROUP
          )
        )
      )
    this.productEntities$ = this.store.select(productSelectors.selectEntities)

    this.bookableProducts$ = this.allProducts$.pipe(
      map((product) => {
        return product.filter((product) => product.bookable)
      })
    )
  }
  private getOrgAbbrv(
    booking: any,
    participationEntites: any,
    organizationEntities: any
  ) {
    let orgAbbrv = []
    booking?.participations?.forEach((parti) => {
      if (
        participationEntites[parti]?.organizationId &&
        organizationEntities[participationEntites[parti]?.organizationId]
      ) {
        orgAbbrv.push(
          organizationEntities[participationEntites[parti]?.organizationId]
            ?.abbreviation
        )
      }
    })
    orgAbbrv = Array.from(new Set(orgAbbrv.filter((item) => item != null)))
    return orgAbbrv?.length == 0
      ? null
      : orgAbbrv[0].length > 4
        ? orgAbbrv[0].slice(0, 4)
        : orgAbbrv[0]
  }
  public onSlotClick({ groupId, slot }) {
    this.productEntities$.pipe(take(1)).subscribe((productEntities) => {
      const modalRef = this.modalService.show(BookingCreateComponent, {
        initialState: {
          bookingPartial: {
            startDate: moment(slot.scheduleSlotStart)
              .startOf('hours')
              .toISOString(),
            endDate: moment(slot.scheduleSlotStart)
              .startOf('hours')
              .add(1, 'hours')
              .toISOString(),
            productId: groupId,
            product: productEntities[groupId]
          },
          activeTab: 'generalForm',
          selectedBookingCreateType: BookingCreationType.DEFAULT,
          createBookingFromSchedule: true
        },
        class: 'modal-xl modal-dialog-scrollable modal-dialog-centered'
      })

      modalRef.onHide.pipe(take(1)).subscribe((modal) => {
        this.selectedDay$.pipe(take(1)).subscribe((selectedDay) => {
          // this.store.dispatch(bookingActions.resetState())
          this.store.dispatch(
            bookingActions.fetchMany({
              params: RequestQueryBuilder.create({
                join: [
                  // { field: 'product' },
                  // { field: 'linkedProduct' },
                  { field: 'allowedLinkedProducts' },
                  // { field: 'product.dependantProducts' },
                  { field: 'participations' },
                  { field: 'participations.organization' }
                ],
                search: {
                  startDate: {
                    [CondOperator.GREATER_THAN_EQUALS]: moment(
                      selectedDay?.toISOString()
                    )
                      .subtract(2, 'hour')
                      ?.toISOString()
                  },
                  endDate: {
                    [CondOperator.LOWER_THAN]: moment(
                      selectedDay.clone().add(24, 'hours').toISOString()
                    )
                      .add(2, 'hour')
                      ?.toISOString()
                  }
                }
              })
            })
          )
        })
      })
    })
  }
  onClickEvent(slot: BookableSlot) {
    const bsModalRef = this.modalService.show(BookingShowModalComponent, {
      initialState: {
        scheduleFlow: true,
        bookingId: slot.bookingId,
        shouldControlOperations:
          this.bookingId && slot.bookingId == this.bookingId,
        activeTab:
          this.bookingId && slot.bookingId == this.bookingId
            ? 'participants'
            : 'general'
      },
      class: 'modal-xxl modal-dialog-scrollable'
    })
    bsModalRef.onHide.pipe(take(1)).subscribe(() => {
      this.store.dispatch(
        BreadCrumbActions.initHistory({
          pageName: 'bookingModule.bookings',
          url: `/bookings`,
          titleName: ['bookingModule.bookings', 'general.schedule']
        })
      )
    })
    if (this.bookingId) {
      this.subscriptions.push(
        bsModalRef.onHide
          .pipe(take(1))
          // add timeout here
          .subscribe((modal) => {
            if (this.bookingId && this.bookingId == slot.bookingId) {
              // this.store.select
              this.store.dispatch(
                bookingActions.fetchMany({
                  params: RequestQueryBuilder.create({
                    search: { id: slot.bookingId },
                    join: [{ field: 'participations' }]
                  })
                })
              )
              this.actions$
                .pipe(
                  ofType(bookingActions.upsertMany),
                  take(1),
                  timeout(4000),
                  catchError((error) => of(null))
                )
                .subscribe((action) => {
                  if (!action || action?.entities?.length == 0) {
                    this.store.dispatch(
                      bookingActions.removeOne({ id: this.bookingId })
                    )
                  } else {
                    this.store.dispatch(
                      bookingActions.fetchOneById({
                        id: slot.bookingId,
                        params: RequestQueryBuilder.create({
                          join: [{ field: 'participations' }]
                        })
                      })
                    )
                  }
                })
            }
          })
      )
    } else {
      this.subscriptions.push(
        bsModalRef.content.updateBookings
          .pipe(take(1))
          // add timeout here
          .subscribe((updateBooking) => {
            if (updateBooking) {
              this.store.dispatch(
                bookingActions.fetchOneById({
                  id: slot.bookingId,
                  params: RequestQueryBuilder.create({
                    join: [{ field: 'participations' }]
                  })
                })
              )
            }
          })
      )
    }
  }

  ngOnDestroy() {
    this.bookingId = null
    this.subscriptions.map((s) => s.unsubscribe())
  }

  public onSearchProducts(term: string) {
    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            description: { [CondOperator.CONTAINS_LOW]: term }
          },
          join: [{ field: 'products' }]
        })
      })
    )
  }
  public onSearchProductGroups(term: string) {
    this.store.dispatch(
      productGroupActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            description: { [CondOperator.CONTAINS_LOW]: term }
          },
          join: [{ field: 'products' }]
        })
      })
    )
  }

  private isFiltersEmpty(selectedProductGroupIds, selectedBookableProductIds) {
    return (
      !selectedProductGroupIds?.length && !selectedBookableProductIds?.length
    )
  }
  public onDaySelected(day: moment.Moment) {
    this.selectedDay$.next(day.clone())
  }

  private fetchProductsById(productIds: number[]) {
    const uniqueIds = Array.from(
      new Set(productIds.filter((id) => Boolean(id)))
    )

    const fetchableProductIds = uniqueIds.filter(
      (id) => !this.didFetchProductIds.get(id)
    )

    if (fetchableProductIds.length > 0) {
      this.store.dispatch(
        productActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              id: { [CondOperator.IN]: fetchableProductIds }
            },
            join: [{ field: 'dependantProducts' }, { field: 'translations' }]
          })
        })
      )
      fetchableProductIds.forEach((id) => this.didFetchProductIds.set(id, true))
    }
  }
}
